/**
 * Schermo vuoto: che cosa e' successo e che cosa fare. Senza scuse (§ 12.1).
 */
import type { ReactNode } from 'react'

export function EmptyState({
  title,
  action,
  children,
}: {
  title: string
  action: string
  children?: ReactNode
}): JSX.Element {
  return (
    <div className="empty-state">
      <h2 className="t-panel">{title}</h2>
      <p className="t-read">{action}</p>
      {children}
    </div>
  )
}
